var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"svgWrapper",class:{'new': _vm.newCount > 0},attrs:{"count":_vm.newCount},domProps:{"innerHTML":_vm._s(require('!!html-loader!@/assets/styles/frontend-library/images/' + _vm.icon +'.svg'))}})}
var staticRenderFns = []

export { render, staticRenderFns }